import { render, staticRenderFns } from "./ques.vue?vue&type=template&id=3b8e4c05&scoped=true"
import script from "./ques.vue?vue&type=script&lang=js"
export * from "./ques.vue?vue&type=script&lang=js"
import style0 from "./ques.vue?vue&type=style&index=0&id=3b8e4c05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e4c05",
  null
  
)

export default component.exports